
import { h } from 'preact'
import './style.less'

export default ({ url = 'about:blank', children }) => {
	return (
		<div className="browser">
			<div className="browser__bar">
				<svg className="browser__bar__svg" width="101" height="20" viewBox="0 0 101 20" fill="none" xmlns="http://www.w3.org/2000/svg">

					{/* traffic lights */}
					<circle cx="10" cy="10" r="4.5" stroke="white" vector-effect="non-scaling-stroke" />
					<circle cx="27" cy="10" r="4.5" stroke="white" vector-effect="non-scaling-stroke" />
					<circle cx="44" cy="10" r="4.5" stroke="white" vector-effect="non-scaling-stroke" />
					
					{/* left arrow */}
					<path className="browser__bar__svg__arrow" d="M 70 5 l -5 5 l 5 5" stroke="white" stroke-linecap="round" vector-effect="non-scaling-stroke" />
					<path className="browser__bar__svg__arrow" d="M 77 10 l -12 0" stroke="white" stroke-linecap="round" vector-effect="non-scaling-stroke" />

					{/* right arrow */}
					<path className="browser__bar__svg__arrow" d="M 95 5 l 5 5 l -5 5" stroke="white" stroke-linecap="round" vector-effect="non-scaling-stroke" />
					<path className="browser__bar__svg__arrow" d="M 100 10 l -12 0" stroke="white" stroke-linecap="round" vector-effect="non-scaling-stroke" />

				</svg>

				<div className="browser__address">{ url }</div>
			</div>
			<div className="browser__body">
				{ children }
			</div>
		</div>
	)
}

